// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.command-frame {
  position: relative;
  font-size: 14px;
  line-height: 17px;
  word-break: break-all;
  white-space: pre-wrap;
  border: 1px solid var(--color-border-base);
}
.command-frame__command {
  font-family: 'JetBrains Mono';
  color: var(--color-content-base);
  background: var(--color-background-base);
  border-color: var(--color-border-base);
  padding: 16px / 2;
  overflow: auto;
  border-right: var(--color-content-base) 30px solid;
}
.command-frame__command--oneliner {
  padding: 0;
}
.command-frame__copy {
  position: absolute;
  top: calc(50% - 22px / 2);
  right: 0;
}
.command-frame__copy--oneliner {
  position: static;
  vertical-align: middle;
}
.command-frame--transparent {
  border: 0;
  font-size: inherit;
}
.command-frame--transparent .command-frame__command {
  color: inherit;
  background: inherit;
  border: 0;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/common/ui/command-frame/CommandFrame.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EAIE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,0CAAA;AAMF;AAJE;EACE,6BAAA;EACA,gCAAA;EACA,wCAAA;EACA,sCAAA;EACA,iBAAA;EACA,cAAA;EACA,kDAAA;AAMJ;AAJI;EACE,UAAA;AAMN;AAFE;EAEE,kBAAA;EACA,yBAAA;EACA,QAAA;AAGJ;AADI;EACE,gBAAA;EACA,sBAAA;AAGN;AACE;EACE,SAAA;EACA,kBAAA;AACJ;AACM;EACE,cAAA;EACA,mBAAA;EACA,SAAA;AACR","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.command-frame {\n  @copy-to-clipboard-icon-size: 22px;\n  @padding-top: 16px;\n\n  position: relative;\n  font-size: 14px;\n  line-height: 17px;\n  word-break: break-all;\n  white-space: pre-wrap;\n  border: 1px solid var(--color-border-base);\n\n  &__command {\n    font-family: @JetBrainsMono;\n    color: var(--color-content-base);\n    background: var(--color-background-base);\n    border-color: var(--color-border-base);\n    padding: @padding-top / 2;\n    overflow: auto;\n    border-right: var(--color-content-base) 30px solid;\n\n    &--oneliner {\n      padding: 0;\n    }\n  }\n\n  &__copy {\n    @icon-offset: @copy-to-clipboard-icon-size / 2;\n    position: absolute;\n    top: ~'calc(50% - @{icon-offset})';\n    right: 0;\n\n    &--oneliner {\n      position: static;\n      vertical-align: middle;\n    }\n  }\n\n  &--transparent {\n    border: 0;\n    font-size: inherit;\n    .command-frame {\n      &__command {\n        color: inherit;\n        background: inherit;\n        border: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
